export interface ApiErrorOptions {
  cause?: unknown;
  status?: number;
  statusText?: string;
  url?: string;
  responseData?: unknown;
}

export class ApiError extends Error {
  readonly status?: number;
  readonly statusText?: string;
  readonly url?: string;
  readonly responseData?: unknown;

  constructor(message: string, options: ApiErrorOptions = {}) {
    super(message, { cause: options.cause });
    this.name = 'ApiError';
    this.status = options.status;
    this.statusText = options.statusText;
    this.url = options.url;
    this.responseData = options.responseData;
  }
}
